import type { FunctionComponent } from 'react'
import React from 'react'

import { Icon } from '../../Icon'
import type { Icon as IconProps } from '../../Icon/Icon'
import styles from '../Icons.module.scss'

export const GpsIcon: FunctionComponent<IconProps> = ({
  fill,
  width = 68,
  height = 34,
  ...rest
}) => {
  return (
    <Icon
      data-testid="needs-based-filter-icon-gps"
      fill={fill}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      width={width}
      {...rest}
    >
      <g fill="none" fillRule="evenodd">
        <polygon fill="#ffffff" className={styles.white} opacity="0" points="0 34 68 34 68 0 0 0" />
        <path
          d="M46,27 C46,30.314 40.627,33 34,33 C27.373,33 22,30.314 22,27 C22,23.686 27.373,21 34,21 C40.627,21 46,23.686 46,27"
          fill="#0050B3"
          className={styles.interactiveColor}
        />
        <path
          d="M34,2 L34,2 C29.297,2 25.5,5.77 25.5,10.439 C25.5,15.475 32.292,26.067 32.292,26.067 C32.639,26.689 33.34,27 34,27 C34.66,27 35.327,26.689 35.708,26.067 C35.708,26.067 42.5,15.561 42.5,10.445 C42.5,5.776 38.703,2 34,2"
          fill="#ffffff"
          className={styles.white}
        />
        <path
          d="M34.2848029,1.00415363 L34,1 C28.7464033,1 24.5,5.21601508 24.5,10.439 C24.5,12.1979354 25.1987384,14.5343336 26.4439721,17.3563378 C26.9025721,18.3956375 27.4281758,19.4821599 28.0080856,20.6015087 C28.7606228,22.0540651 29.5658261,23.4888729 30.3710487,24.8441096 L31.0059501,25.8952504 L31.4502023,26.6067932 C31.9333507,27.476698 32.9467225,28 34,28 C34.9698864,28 35.8873433,27.5511968 36.4524951,26.7534989 L36.6671145,26.4230305 L36.9923672,25.9031827 L37.2990917,25.4033042 L37.6275153,24.8587062 C38.4330042,23.5116391 39.2384657,22.0837239 39.9912524,20.6357843 C40.5913564,19.4815207 41.1331607,18.3611247 41.602704,17.2901372 C42.8186552,14.5166575 43.5,12.2057905 43.5,10.445 C43.5,5.32670027 39.4165001,1.15401935 34.2848029,1.00415363 Z M34,3 L34.2410304,3.00362116 C38.2800917,3.12168445 41.5,6.41191341 41.5,10.445 C41.5,11.859561 40.8843194,13.9477199 39.7710092,16.4870841 C39.3204281,17.5148207 38.7975603,18.5960577 38.2167476,19.7132157 C37.630377,20.841064 37.0097982,21.958888 36.3823918,23.0342453 L35.7483383,24.10314 L35.2921598,24.8499518 L34.8682112,25.5240868 C34.6791663,25.8321455 34.3587045,26 34,26 C33.6751355,26 33.3784261,25.8654201 33.2186007,25.6600258 L32.8499916,25.0749908 L32.4107871,24.3572064 L32.0904513,23.8225154 C31.3037989,22.4985334 30.5171272,21.0967474 29.7839144,19.6814913 C29.2221561,18.5971787 28.7144174,17.5475867 28.2737522,16.5489316 C27.1327191,13.9630715 26.5,11.8474245 26.5,10.439 C26.5,6.32381276 29.8477701,3 34,3 Z"
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
        />
        <path
          d="M38,10 C38,12.209 36.209,14 34,14 C31.791,14 30,12.209 30,10 C30,7.791 31.791,6 34,6 C36.209,6 38,7.791 38,10"
          fill="#00000"
          className={styles.defaultColor}
        />
      </g>
    </Icon>
  )
}
